import { useRemovePersonFromPositionMutation } from "@/features/projects/graphql/generated";

export const useRemoveCandidateFromPosition = (positionId: number) => {
  const [removePerson, { loading }] = useRemovePersonFromPositionMutation({
    refetchQueries: ["Project", "People"],
  });

  /**
   * TA-145: `keepAccess` ends the candidacy but leaves the person's project access
   * intact (they stay a collaborator). Without it, removing a candidate who holds
   * access silently revokes it — which can lock out the person doing the removing.
   */
  const handleRemoveCandidateFromPosition = async (
    personId: number,
    keepAccess = false
  ) => {
    const result = await removePerson({
      variables: { personId, positionId, keepAccess },
    });
    return result.data?.removePersonFromPosition;
  };

  return { handleRemoveCandidateFromPosition, loading };
};
